import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import './Sohbet.css';

// Backend'de "Sohbet" tek bir kategori — bu alt-başlıklar backend'de yok,
// sadece post oluştururken tag olarak ekleyip client-side filtrelemek için
// kullanıyoruz (CodeSoruSor.js'in code-question tag'i gibi aynı desen).
const SUB_CATEGORIES = [
    { label: 'Genel', tag: 'genel' },
    { label: 'Ders & Ödev', tag: 'ders-odev' },
    { label: 'Staj & Kariyer', tag: 'staj-kariyer' },
    { label: 'Geyik & Kahve', tag: 'geyik-kahve' },
];

function formatDate(dateString) {
    if (!dateString) return 'Yakın zamanda';
    return new Date(dateString).toLocaleDateString('tr-TR', {
        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
    });
}

function Sohbet({ user, toggleSavePost, savedPosts = [] }) {
    const navigate = useNavigate();

    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sohbetCategoryId, setSohbetCategoryId] = useState(null);

    const [newTitle, setNewTitle] = useState("");
    const [selectedTag, setSelectedTag] = useState(SUB_CATEGORIES[0].tag);
    const [filterTag, setFilterTag] = useState("Tümü");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Sohbet kategorisinin gerçek id'sini bir kere çek (sabit kodlamıyoruz,
    // backend'de değişebilir).
    useEffect(() => {
        API.get('/categories/sohbet')
            .then(res => setSohbetCategoryId(res.data?.id))
            .catch(() => setSohbetCategoryId(null));
    }, []);

    const fetchTopics = useCallback(() => {
        setLoading(true);
        API.get('/posts?category=sohbet')
            .then(res => setTopics(res.data || []))
            .catch(() => setTopics([]))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        fetchTopics();
    }, [fetchTopics]);

    // --- YENİ SOHBET BAŞLIĞI AÇMA FONKSİYONU ---
    const handleCreateTopic = async (e) => {
        e.preventDefault();
        if (!newTitle.trim()) return;

        if (!user) {
            alert("Konu açmak için giriş yapmalısın.");
            return;
        }

        if (!sohbetCategoryId) {
            alert("Sohbet kategorisi yüklenemedi, sayfayı yenileyip tekrar dene.");
            return;
        }

        try {
            setIsSubmitting(true);
            // NOT: backend content alanını zorunlu tutuyor, sohbet formunda ayrı
            // bir açıklama kutusu olmadığı için başlığı content olarak da gönderiyoruz.
            const createRes = await API.post('/posts', {
                title: newTitle.trim(),
                content: newTitle.trim(),
                categoryId: sohbetCategoryId,
                tags: [selectedTag]
            });

            const detailRes = await API.get(`/posts/${createRes.data.postId}`);
            setTopics(prev => [detailRes.data, ...prev]);
            setNewTitle("");
        } catch (err) {
            alert("Konu açılırken hata oluştu: " + err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Etiket filtresine göre konuları süz
    const filteredTopics = topics.filter(t => {
        if (filterTag === "Tümü") return true;
        return Array.isArray(t.tags) && t.tags.includes(filterTag);
    });

    return (
        <div className="sohbet-forum-page">
            <div className="sohbet-welcome">
                <h1>Serbest Kürsü & Sohbet Odası</h1>
                <p>İstediğin konuda yeni bir tartışma başlığı aç, toplulukla fikir alışverişi yap.</p>
            </div>

            {/* Konu Açma Kutusu */}
            <form className="create-topic-box" onSubmit={handleCreateTopic}>
                <h3>💬 Yeni Bir Sohbet Başlığı Aç</h3>
                <input
                    type="text"
                    placeholder={user ? "Tartışmak istediğin konunun başlığı nedir? (Örn: Mantık tasarımı ödevi hakkında...)" : "Konu açmak için giriş yapmalısın"}
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.target.value)}
                    disabled={!user}
                />
                <div className="create-topic-footer">
                    <select value={selectedTag} onChange={(e) => setSelectedTag(e.target.value)} disabled={!user}>
                        {SUB_CATEGORIES.map(cat => (
                            <option key={cat.tag} value={cat.tag}>{cat.label}</option>
                        ))}
                    </select>
                    <button type="submit" disabled={!user || !newTitle.trim() || isSubmitting}>
                        {isSubmitting ? 'Açılıyor...' : 'Konuyu Başlat'}
                    </button>
                </div>
            </form>

            {/* Konu Başlıkları Listesi */}
            <div className="topics-list-container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h2>Aktif Tartışmalar</h2>

                    {/* Etiket Filtre Butonları */}
                    <div className="category-filter-bar" style={{ display: 'flex', gap: '8px' }}>
                        <button
                            type="button"
                            onClick={() => setFilterTag("Tümü")}
                            style={{
                                padding: '5px 10px', borderRadius: '15px', border: '1px solid var(--line-strong)',
                                fontSize: '12px', cursor: 'pointer',
                                background: filterTag === "Tümü" ? 'var(--accent)' : 'var(--bg)',
                                color: filterTag === "Tümü" ? '#fff' : 'var(--ink)'
                            }}
                        >
                            Tümü
                        </button>
                        {SUB_CATEGORIES.map(cat => (
                            <button
                                key={cat.tag}
                                type="button"
                                onClick={() => setFilterTag(cat.tag)}
                                style={{
                                    padding: '5px 10px', borderRadius: '15px', border: '1px solid var(--line-strong)',
                                    fontSize: '12px', cursor: 'pointer',
                                    background: filterTag === cat.tag ? 'var(--accent)' : 'var(--bg)',
                                    color: filterTag === cat.tag ? '#fff' : 'var(--ink)'
                                }}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>
                </div>

                {loading ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: 'var(--muted)' }}>Yükleniyor...</div>
                ) : filteredTopics.length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: 'var(--muted)', background: '#fff', borderRadius: '8px' }}>
                        Bu kategoride henüz hiç sohbet başlığı bulunmuyor.
                    </div>
                ) : (
                    filteredTopics.map(topic => {
                        const isSaved = savedPosts.some(p => p.id === topic.id);
                        const authorName = topic.author?.username || (typeof topic.author === 'string' ? topic.author : null) || 'Anonim';
                        const subCategoryLabel = SUB_CATEGORIES.find(c => (topic.tags || []).includes(c.tag))?.label || 'Diğer';

                        return (
                            <div
                                key={topic.id}
                                className="topic-row-card"
                                onClick={() => navigate(`/sohbet/${topic.id}`)}
                            >
                                <button
                                    className={`instagram-save-btn ${isSaved ? 'saved' : ''}`}
                                    onClick={(e) => {
                                        e.stopPropagation(); // Kart tıklamasını engeller
                                        toggleSavePost && toggleSavePost(topic);
                                    }}
                                    aria-label="Kaydet"
                                >
                                    {isSaved ? (
                                        <svg aria-label="Kaydedildi" color="currentColor" fill="currentColor" height="22" role="img" viewBox="0 0 24 24" width="22">
                                            <path d="M20 22a.75.75 0 0 1-.516-.2l-7.484-6.804-7.484 6.804A.75.75 0 0 1 3.25 22V3.75A2.75 2.75 0 0 1 6 1h12a2.75 2.75 0 0 1 2.75 2.75Z"></path>
                                        </svg>
                                    ) : (
                                        <svg aria-label="Kaydet" color="var(--muted)" fill="var(--muted)" height="22" role="img" viewBox="0 0 24 24" width="22">
                                            <path d="M20 22a.75.75 0 0 1-.516-.2l-7.484-6.804-7.484 6.804A.75.75 0 0 1 3.25 22V3.75A2.75 2.75 0 0 1 6 1h12a2.75 2.75 0 0 1 2.75 2.75ZM4.75 3.75V19.041l6.734-6.122a.75.75 0 0 1 1.032 0l6.734 6.122V3.75A1.25 1.25 0 0 0 18 2.5H6a1.25 1.25 0 0 0-1.25 1.25Z"></path>
                                        </svg>
                                    )}
                                </button>

                                <div className="topic-info-side">
                                    <span className="topic-category-tag">{subCategoryLabel}</span>
                                    <h3 className="topic-row-title">{topic.title}</h3>
                                    <div className="topic-row-meta">
                                        <span>Açan: <strong>@{authorName}</strong></span> • <span>{formatDate(topic.created_at)}</span>
                                    </div>
                                </div>
                                <div className="topic-stats-side">
                                    <span className="reply-number">💬 {topic.comment_count ?? 0}</span>
                                    <span className="reply-text">yanıt</span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default Sohbet;